import { captureException } from '@sentry/vue';

import { env } from '../../constants';

export function usePosthog() {
  const posthogInstance = ref<Posthog.PosthogWebSdk | undefined>();

  const developmentDebugger = (eventName: Posthog.PosthogEventName, eventValue?: Posthog.PosthogEventValue) => {
    if (env.APP_MODE !== 'development') return;

    // eslint-disable-next-line no-console
    console.group(`Posthog event "${eventName}"`);
    // eslint-disable-next-line no-console
    console.table(eventValue);
    // eslint-disable-next-line no-console
    console.groupEnd();
  };

  const defaultFallback = (eventName: Posthog.PosthogEventName, eventValue?: Posthog.PosthogEventValue) : void => {
    const err = new Error('posthog instance is not defined yet');

    developmentDebugger(eventName, eventValue);

    captureException(err, {
      tags: { posthogWebSdk: true },
    });
  };

  const initPosthog = () => {
    const { posthog } = window;

    if (!posthog) return;

    posthogInstance.value = posthog;
  };

  initPosthog();

  return {
    capture: posthogInstance.value?.capture || defaultFallback,
  };
}
